import { Routes, Route } from 'react-router-dom';
import Home from '../routes/Home';
import Services from '../routes/Services';
import Development from '../routes/Development';
import BestPractices from '../routes/BestPractices';
import ServerlessApplications from '../routes/ServerlessApplications';
import CICD from '../routes/CICD';
import Integration from '../routes/Integration';
import Java from '../routes/Java';
import Design from '../routes/Design';
import WellArchitected from '../routes/WellArchitected';
import ServerlessArchitecture from '../routes/ServerlessArchitecture';
import Database from '../routes/Database';
import BusinessAnalysis from '../routes/BusinessAnalysis';
import Security from '../routes/Security';
import Maintenance from '../routes/Maintenance';
import Monitoring from '../routes/Monitoring';
import CostOptimization from '../routes/CostOptimization';
import Audit from '../routes/Audit';
import Interview from '../routes/Interview';
import Training from '../routes/Training';
import Other from '../routes/Other';
import AboutWho from '../routes/AboutWho';
import Contact from '../routes/Contact';
import Insights from "../routes/Insights";
import AwsCourseLaunch from "../routes/AwsCourseLaunch";
import AwsCourseSkillshare from "../routes/AwsCourseSkillshare";
import AwsAiPractitioner from "../routes/AwsAiPractitioner";
import AwsDataEngineer from "../routes/AwsDataEngineer";
import AwsCourseUdemy from "../routes/AwsCourseUdemy";
import ServerlessCandidateSystem from "../routes/ServerlessCandidateSystem";
import AwsDevOpsProfessional from "../routes/AwsDevOpsProfessional";
import AwsMachineLearningSpecialty from "../routes/AwsMachineLearningSpecialty";
import AwsDatabaseSpecialty from "../routes/AwsDatabaseSpecialty";
import AwsSecuritySpecialty from "../routes/AwsSecuritySpecialty";
import AwsSolutionsArchitectProfessional from "../routes/AwsSolutionsArchitectProfessional";
import AwsSolutionsArchitectAssociate from "../routes/AwsSolutionsArchitectAssociate";
import AwsDeveloperAssociate from "../routes/AwsDeveloperAssociate";
import AwsArchitecture from "../routes/AwsArchitecture"
import CloudDevelopment from "../routes/CloudDevelopment"
import Optimization from "../routes/Optimization"
import EndToEndOwnership from "../routes/EndToEndOwnership"
import ProductionFocused from "../routes/ProductionFocused"
import Layout from './Layout';

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="development" element={<Development />} />
          <Route path="best-practices" element={<BestPractices />} />
          <Route path="serverless-applications" element={<ServerlessApplications />} />
          <Route path="ci-cd" element={<CICD />} />
          <Route path="integration" element={<Integration />} />
          <Route path="java" element={<Java />} />
          <Route path="design" element={<Design />} />
          <Route path="well-architected" element={<WellArchitected />} />
          <Route path="serverless-architecture" element={<ServerlessArchitecture />} />
          <Route path="database" element={<Database />} />
          <Route path="business-analysis" element={<BusinessAnalysis />} />
          <Route path="security" element={<Security />} />
          <Route path="maintenance" element={<Maintenance />} />
          <Route path="monitoring" element={<Monitoring />} />
          <Route path="cost-optimization" element={<CostOptimization />} />
          <Route path="audit" element={<Audit />} />
          <Route path="other-services" element={<Other />} />
          <Route path="interview" element={<Interview />} />
          <Route path="training" element={<Training />} />
          <Route path="other" element={<Other />} />
          <Route path="about" element={<AboutWho />} />
          <Route path="who-we-are" element={<AboutWho />} />
          <Route path="contact" element={<Contact />} />
          <Route path="insights" element={<Insights />} />
          <Route path="aws-course-launch" element={<AwsCourseLaunch />} />
          <Route path="aws-course-skillshare" element={<AwsCourseSkillshare />} />
          <Route path="/aws-ai-practitioner" element={<AwsAiPractitioner />} />
          <Route path="/aws-data-engineer" element={<AwsDataEngineer />} />
          <Route path="/aws-course-udemy" element={<AwsCourseUdemy />} />
          <Route path="/serverless-candidate-system" element={<ServerlessCandidateSystem />} />
          <Route path="/aws-devops-professional" element={<AwsDevOpsProfessional />} />
          <Route path="/aws-ml-specialty" element={<AwsMachineLearningSpecialty />} />
          <Route path="/aws-database-specialty" element={<AwsDatabaseSpecialty />} />
          <Route path="/aws-security-specialty" element={<AwsSecuritySpecialty />} />
          <Route path="/aws-solutions-architect-professional" element={<AwsSolutionsArchitectProfessional />} />
          <Route path="/aws-solutions-architect-associate" element={<AwsSolutionsArchitectAssociate />} />
          <Route path="/aws-developer-associate" element={<AwsDeveloperAssociate />} />
          <Route path="/services/aws-architecture" element={<AwsArchitecture />} />
          <Route path="/services/cloud-development" element={<CloudDevelopment />} />
          <Route path="/services/optimization" element={<Optimization />} />
          <Route path="end-to-end-ownership" element={<EndToEndOwnership />} />
          <Route path="production-focused" element={<ProductionFocused />} />
          <Route path="*" element={<p>Not found!</p>} />
        </Route>
      </Routes>
    </>
  );
};

export default App;
